var _title, _g, _rect, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgRoundedCover = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f8487254-13e0-4e35-9a38-8d8d32cd3bab",
    "data-name": "Layer 1",
    viewBox: "0 0 28 28",
    ref: svgRef
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "icon-rounded-cover-page-hollow")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23,.5A4.50508,4.50508,0,0,1,27.5,5V23A4.50508,4.50508,0,0,1,23,27.5H5A4.50508,4.50508,0,0,1,.5,23V5A4.50508,4.50508,0,0,1,5,.5H23M23,0H5A5,5,0,0,0,0,5V23a5,5,0,0,0,5,5H23a5,5,0,0,0,5-5V5a5,5,0,0,0-5-5Z",
    fill: "#333"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 9.00006,
    width: 14,
    height: 10,
    rx: 2,
    strokeWidth: 1.25,
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 13.00006,
    x2: 17,
    y2: 13.00006,
    fill: "none",
    opacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75,
    stroke: "#333"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 15.00006,
    x2: 17,
    y2: 15.00006,
    fill: "none",
    opacity: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75,
    stroke: "#333"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRoundedCover, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/rounded-cover.4eee149b.svg";
export { ForwardRef as ReactComponent };